import { COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME } from '../ui/constants/comments.tooltip.constants';


export function getKeymap(UIExtension) {
    const { BuiltinShortcutContext } = UIExtension.PDFViewCtrl.keyboard;
    return [{
        context: COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME,
        topLayers: [BuiltinShortcutContext.VIEWER],
        extends: [BuiltinShortcutContext.CLOSABLE_LAYER, BuiltinShortcutContext.ACTIVATION_ANNOTATION],
        shortcuts: []
    }]
};
